import { Flex } from "@faire/web/slate/Layout";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import React from "react";

import { DesktopDottedTooltip } from "./DesktopDottedTooltip";
import { MobileDottedTooltip } from "./MobileDottedTooltip";
import { IDottedTooltipProps } from "./SharedTooltipProps";

export const DottedTooltip: React.FC<IDottedTooltipProps> = (props) => {
  const { isMobile } = useViewport();
  return (
    <Flex>
      {isMobile ? (
        <MobileDottedTooltip {...props} />
      ) : (
        <DesktopDottedTooltip {...props} />
      )}
    </Flex>
  );
};
